// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountTypePropertyDto
 */
export interface IAccountTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IAccountTypePropertyDto
     */
    account_type?: IAccountTypePropertyDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountTypePropertyDto
     */
    account_type_state?: IAccountTypePropertyDtoAccountTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountTypePropertyDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}
/**
* @export
* @enum {string}
*/
export enum IAccountTypePropertyDtoAccountTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IAccountTypePropertyDto interface.
 */
export function instanceOfIAccountTypePropertyDto(value: object): value is IAccountTypePropertyDto {
    return true;
}

export function IAccountTypePropertyDtoFromJSON(json: any): IAccountTypePropertyDto {
    return IAccountTypePropertyDtoFromJSONTyped(json, false);
}

export function IAccountTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_type_state': json['account_type_state'] == null ? undefined : json['account_type_state'],
    };
}

export function IAccountTypePropertyDtoToJSON(json: any): IAccountTypePropertyDto {
    return IAccountTypePropertyDtoToJSONTyped(json, false);
}

export function IAccountTypePropertyDtoToJSONTyped(value?: IAccountTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_type': value['account_type'],
        'account_type_state': value['account_type_state'],
    };
}

